// src/components/About/About.jsx

import React from "react";
import { FaArrowDown } from "react-icons/fa";

import {
  t as translate,
  normalizeLang,
  getLangFromPathname,
} from "../../i18n";
import { useSiteContent } from "../../content/SiteContentContext";

const fireEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", name, params);
  }
};

const About = ({ lang: langProp } = {}) => {
  useSiteContent();
  // Home välittää normaalisti kielen propina.
  // Jos Aboutia käytetään ilman lang-propia,
  // päätellään kieli selaimen oikeasta URL:sta.
  const pathname =
    typeof window !== "undefined"
      ? window.location.pathname
      : "/";

  const lang =
    typeof langProp === "string" && langProp
      ? normalizeLang(langProp)
      : getLangFromPathname(pathname);

  // Käytetään yhteistä i18n.js:n t()-funktiota,
  // jotta sama käännöslogiikka ei toistu tässä komponentissa.
  const t = (key, vars) => translate(key, lang, vars);

  return (
    <div className="mb-24">
      <section
        id="about"
        className="mx-auto mt-8 w-full scroll-mt-24 px-2 sm:px-4 md:px-6 lg:px-12 xl:px-16"
        aria-label={t("about.ariaLabel")}
      >
        <div className="mx-auto w-full max-w-6xl">
          <div className="rounded-[2rem] border border-black/10 bg-white/70 px-6 py-8 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:px-10 md:py-10">
            <div className="grid gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:items-start">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.24em] text-black/50 dark:text-white/45">
                  Arttu Stenius
                </p>

                <h2 className="mt-3 text-3xl font-bold text-black dark:text-white md:text-4xl">
                  {t("about.title")}
                </h2>

                <p className="mt-5 text-base font-light leading-relaxed text-black/80 dark:text-white/80 md:text-lg">
                  {t("about.lead")}
                </p>

                <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                  <a
                    href="#works"
                    onClick={() => fireEvent("portfolio_klikattu_minusta")}
                    className="inline-flex items-center justify-center rounded-full bg-black px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:shadow-lg dark:bg-white dark:text-black"
                  >
                    {t("about.portfolio.link")}
                  </a>

                  <a
                    href="#contact"
                    onClick={() =>
                      fireEvent("yhteydenotto_klikattu_minusta")
                    }
                    className="inline-flex items-center justify-center rounded-full border border-black/15 bg-white/70 px-5 py-3 text-sm font-bold text-black transition hover:-translate-y-0.5 hover:shadow-lg dark:border-white/15 dark:bg-white/5 dark:text-white"
                  >
                    {t("about.contact")}
                  </a>
                </div>
              </div>

              <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3">
                <div className="rounded-2xl border border-black/10 bg-white/80 px-4 py-4 dark:border-white/10 dark:bg-white/5">
                  <div className="text-sm font-bold text-black dark:text-white">
                    {t("about.cards.fast.title")}
                  </div>

                  <div className="mt-1 text-sm leading-relaxed text-black/70 dark:text-white/70">
                    {t("about.cards.fast.desc")}
                  </div>
                </div>

                <div className="rounded-2xl border border-black/10 bg-white/80 px-4 py-4 dark:border-white/10 dark:bg-white/5">
                  <div className="text-sm font-bold text-black dark:text-white">
                    {t("about.cards.seo.title")}
                  </div>

                  <div className="mt-1 text-sm leading-relaxed text-black/70 dark:text-white/70">
                    {t("about.cards.seo.desc")}
                  </div>
                </div>

                <div className="rounded-2xl border border-black/10 bg-white/80 px-4 py-4 dark:border-white/10 dark:bg-white/5">
                  <div className="text-sm font-bold text-black dark:text-white">
                    {t("about.cards.fullstack.title")}
                  </div>

                  <div className="mt-1 text-sm leading-relaxed text-black/70 dark:text-white/70">
                    {t("about.cards.fullstack.desc")}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex justify-center border-t border-black/10 pt-8 dark:border-white/10">
              <a
                href="#works"
                onClick={() => fireEvent("minusta_nuoli_klikattu")}
                className="rounded-full border border-black/10 bg-white/70 p-3 transition hover:-translate-y-0.5 hover:shadow-lg dark:border-white/10 dark:bg-white/5"
                aria-label={t("about.arrowTitle")}
                title={t("about.arrowTitle")}
              >
                <FaArrowDown className="h-5 w-5 text-black dark:text-white" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
